var StringUtil = {
  capitalize: function (string) {
    if (typeof string !== 'string') {
      return null;
    }

    return string.charAt(0).toUpperCase() + string.slice(1, string.length);
  }
};

module.exports = StringUtil;



//////////////////
// WEBPACK FOOTER
// ./~/mesosphere-shared-reactjs/utils/StringUtil.js
// module id = 784
// module chunks = 2